<template>
  <div class="insurance-list-container">
    <div class="card-container">
      <!-- 查询区域 -->
      <div class="query-section">
        <!-- 保单号 -->
        <div class="query-item">
          <span class="query-label">保单号</span>
          <el-input
            v-model="policyNo"
            placeholder="请输入保单号"
            style="width: 200px;"
            clearable
          >
          </el-input>
        </div>

        <!-- 批单号 -->
        <div class="query-item">
          <span class="query-label">批单号</span>
          <el-input
            v-model="correctionNo"
            placeholder="请输入批单号"
            style="width: 200px;"
            clearable
          >
          </el-input>
        </div>

        <!-- 投保人 -->
        <div class="query-item">
          <span class="query-label">投保人</span>
          <el-input
            v-model="appliRealName"
            placeholder="请输入投保人"
            style="width: 200px;"
            clearable
          >
          </el-input>
        </div>

        <!-- 生效时间 -->
        <div class="query-item">
          <span class="query-label">生效时间</span>
          <el-date-picker
            v-model="correctionStartTimeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            style="width: 280px;"
            clearable
          >
          </el-date-picker>
        </div>

        <!-- 状态 -->
        <!--        <div class="query-item">-->
        <!--          <span class="query-label">状态</span>-->
        <!--          <el-select-->
        <!--            v-model="policyStatus"-->
        <!--            placeholder="请选择状态"-->
        <!--            style="width: 200px;"-->
        <!--            clearable-->
        <!--          >-->
        <!--            <el-option label="全部状态" value=""></el-option>-->
        <!--            <el-option label="生效" value="1"></el-option>-->
        <!--            <el-option label="失效" value="0"></el-option>-->
        <!--            <el-option label="暂停" value="2"></el-option>-->
        <!--          </el-select>-->
        <!--        </div>-->

        <div class="query-buttons">
          <el-button type="primary" @click="fetchInsuranceList" class="query-button">查询</el-button>
          <el-button type="default" @click="resetQuery" class="reset-button">重置</el-button>
        </div>
      </div>

      <!-- 列表区域：添加滚动容器 -->
      <div class="table-scroll-container">
        <el-table
          :data="insuranceList"
          border
          style="width: 100%;"
          v-loading="loading"
          :loading-text="'正在加载数据...'"
          class="insurance-table"
        >
          <!-- 所有列保持不变 -->
          <el-table-column prop="policyNo" width="350" label="保单号"></el-table-column>
          <el-table-column prop="correctionNo" width="350" label="批单号"></el-table-column>
          <el-table-column prop="appliRealName" width="350" label="投保人"></el-table-column>
          <el-table-column prop="correctionStartDate" label="批改生效时间"></el-table-column>
          <el-table-column prop="duePremium" label="保费"></el-table-column>
          <el-table-column prop="payUrl" width="150" label="批改支付链接">
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-document-copy"
                @click="copyPaymentLink(scope.row.payUrl)"
                :disabled="!scope.row.payUrl || scope.row.correctionFileUrl"
              >
                复制链接
              </el-button>
            </template>
          </el-table-column>

          <!-- 添加操作列 -->
          <el-table-column label="下载电子批单" width="250">
            <template slot-scope="scope">
              <div class="operation-buttons">
                <!-- 下载电子批单 -->
                <!--                <a-->
                <!--                  :href="scope.row.correctionFileUrl"-->
                <!--                  download-->
                <!--                  class="download-link"-->
                <!--                  :disabled="!scope.row.correctionFileUrl"-->
                <!--                >-->
                <!--                  下载电子批单-->
                <!--                </a>-->
                <el-button
                  type="text"
                  icon="el-icon-download"
                  @click="downloadCorrectionFile(scope.row.correctionFileUrl)"
                  :disabled="!scope.row.correctionFileUrl"
                >
                  下载电子批单
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页区域 -->
      <div class="pagination-section">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {service} from '../../utils/axios'
import {getToken} from '../../utils/auth'

export default {
  name: 'policyCorrectionList',
  data () {
    return {
      policyNo: '',
      correctionNo: '',
      appliRealName: '',
      selectedProductId: '',
      correctionStartDate: '',
      correctionStartTimeRange: [],
      loading: false,
      insuranceList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  methods: {
    async fetchInsuranceList () {
      this.loading = true
      try {
        const params = {
          pageNo: this.currentPage,
          pageSize: this.pageSize,
          policyNo: this.policyNo,
          correctionNo: this.correctionNo || 'EEIC*',
          appliRealName: this.appliRealName,
          correctionStartDate_begin: this.correctionStartTimeRange && this.correctionStartTimeRange.length > 0 ? this.correctionStartTimeRange[0] : '',
          correctionStartDate_end: this.correctionStartTimeRange && this.correctionStartTimeRange.length > 0 ? this.correctionStartTimeRange[1] : ''
        }
        const res = await service.get('/policyCorrection/policyCorrection/list', {
          params: params,
          headers: {'x-access-token': getToken() || ''},
          timeout: 100000
        })
        if (res.success) {
          this.insuranceList = res.result.records
          this.total = res.result.total
        } else {
          this.$message.error('数据获取失败')
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          this.$message.error('登录过期，请重新登录')
          this.$router.push({path: '/login'})
        }
        console.error('接口请求异常:', error)
        this.$message.error('数据加载失败')
      } finally {
        this.loading = false
      }
    },
    // 添加批改按钮显示控制方法
    shouldShowModifyButton (effectiveBeginTime) {
      if (!effectiveBeginTime) return false
      // 将日期字符串转换为Date对象
      const currentDate = new Date()
      const beginDate = new Date(effectiveBeginTime)
      // 比较当前日期是否在生效日期之前
      return currentDate < beginDate
    },
    // 下载电子批单
    async downloadCorrectionFile (url) {
      if (!url) {
        this.$message.warning('批单文件不存在')
        return
      }

      try {
        this.loading = true
        // 在新窗口中打开URL
        window.open(url, '_blank')
        this.$message.success('已在新窗口打开电子批单')
      } catch (error) {
        console.error('打开失败:', error)
        this.$message.error('打开电子批单失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },
    // 添加批改按钮点击事件
    handleModify (row) {
      // 这里可以添加批改逻辑，例如跳转到批改页面
      this.$router.push({
        path: '/SidebarMenu/modifyPolicy',
        query: {
          productId: row.productId,
          policyNo: row.policyNo,
          productName: row.productName
        }
      })
    },
    copyPaymentLink (url) {
      if (!url) {
        this.$message.warning('支付链接不存在')
        return
      }

      // 使用浏览器剪贴板API复制链接
      navigator.clipboard.writeText(url)
        .then(() => {
          this.$message.success('支付链接已成功复制到剪贴板')
        })
        .catch(() => {
          // 兼容处理：创建临时文本区域复制
          const textarea = document.createElement('textarea')
          textarea.value = url
          document.body.appendChild(textarea)
          textarea.select()
          document.execCommand('copy')
          document.body.removeChild(textarea)
          this.$message.success('支付链接已成功复制到剪贴板')
        })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.fetchInsuranceList()
    }, // 新增重置方法
    resetQuery () {
      this.policyNo = ''
      this.productName = ''
      this.insuredNo = ''
      this.appliName = ''
      this.orderTimeRange = []
      this.policyStatus = ''
      this.currentPage = 1
      this.fetchInsuranceList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchInsuranceList()
    }
  },
  created () {
    this.fetchInsuranceList()
  }
}
</script>

<style scoped>
.insurance-list-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.card-container {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  padding: 20px;
}

.query-button {
  height: 40px;
}

/* 表头样式 */
::v-deep .insurance-table .el-table__header th {
  white-space: nowrap !important;
  background-color: #f5f7fa;
  font-weight: 500;
}

/* 行hover样式 */
::v-deep .insurance-table .el-table__row:hover {
  background-color: #f5f7fa;
}

.pagination-section {
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
}

.download-link {
  color: #409EFF;
  text-decoration: none;
}

.query-section {
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  align-items: center;
  padding: 15px;
  background-color: #f9fafc;
  border-radius: 6px;
}

.query-item {
  display: flex;
  align-items: center;
}

.query-label {
  width: 80px;
  text-align: right;
  margin-right: 8px;
  color: #606266;
  font-size: 14px;
}

.query-buttons {
  margin-left: auto;
}

::v-deep .insurance-table .el-table__row:hover {
  background-color: #f5f7fa;
}

/* 增强表格滚动容器样式 */
.table-scroll-container {
  width: 100%;
  overflow-x: auto; /* 强制显示水平滚动条 */
  margin-bottom: 20px;
  /* 添加内阴影增强视觉效果 */
  box-shadow: inset 0 0 0 1px transparent;
}

/* 确保表格内容足够宽以触发滚动 */
.insurance-table {
  width: 100%;
  min-width: 1300px; /* 增加最小宽度值确保溢出 */
}

/* 优化滚动条样式 */
.table-scroll-container::-webkit-scrollbar {
  height: 10px;
}

.table-scroll-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.table-scroll-container::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

.table-scroll-container::-webkit-scrollbar-thumb:hover {
  background: #999;
}

/* 确保表格单元格内容不换行 */
::v-deep .insurance-table .el-table__cell {
  white-space: nowrap !important;
}

.operation-buttons {
  display: flex;
  gap: 10px;
  align-items: center;
  white-space: nowrap; /* 防止按钮换行 */
  overflow: hidden; /* 隐藏溢出内容 */
  text-overflow: ellipsis; /* 溢出时显示省略号 */
}

/* 调整操作列单元格样式 */
::v-deep .el-table .el-table__cell:last-child {
  padding: 0 10px;
}

</style>



// WEBPACK FOOTER //
// src/views/anDeEIC/policyCorrectionList.vue